import React from 'react';
import { space } from 'styled-system';
import { styled } from '../../../libs/styled.es.js';
import { Input } from '../../atoms/Input/Input.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var FormInputVariants = /* @__PURE__ */ ((FormInputVariants2) => {
  FormInputVariants2["valid"] = "valid";
  FormInputVariants2["invalid"] = "invalid";
  return FormInputVariants2;
})(FormInputVariants || {});
const getColor = (props) => {
  switch (props.variant) {
    case "invalid" /* invalid */:
      return "#dc3545";
    case "valid" /* valid */:
      return "#28a745";
  }
};
const Label = styled.div((props) => {
  const styles = {
    fontWeight: 500,
    lineHeight: "24px",
    marginBottom: "4px",
    fontSize: "13px"
  };
  if (props.required) {
    styles["&:after"] = {
      content: '"*"',
      color: "red",
      marginLeft: "0.5em"
    };
  }
  return styles;
});
const Feedback = styled.div((props) => {
  const styles = {};
  if (getColor(props)) {
    styles.color = getColor(props);
    styles.marginTop = "0.25rem";
  }
  return styles;
});
const StyledInput = styled(Input)((props) => {
  const styles = {};
  styles.height = `40px`;
  if (getColor(props)) {
    styles.borderColor = `${getColor(props)} !important`;
  }
  return styles;
});
const Wrapper = styled.div(space);
const FormInput = (_a) => {
  var _b = _a, {
    label,
    feedback,
    variant,
    required = false,
    children
  } = _b, props = __objRest(_b, [
    "label",
    "feedback",
    "variant",
    "required",
    "children"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), label && /* @__PURE__ */ React.createElement(Label, {
    required,
    className: "form-input__label"
  }, label), children ? children : /* @__PURE__ */ React.createElement(StyledInput, __spreadProps(__spreadValues({}, props), {
    variant,
    className: "form-input__input"
  })), feedback && /* @__PURE__ */ React.createElement(Feedback, {
    variant
  }, feedback));
};

export { FormInput, FormInputVariants };
